//export const baseUrl = 'https://backend-wilbro.herokuapp.com/';
export const siteUrl = "https://wilbro-green-energy.netlify.app/";
//export const siteUrl = "http://localhost:3000/";
//export const baseUrl = "https://backend-master-production.up.railway.app/";
export const baseUrl = "https://backendwilbro.onrender.com/";
